import React, { FC } from "react"

export const CRWaitingBanner: FC<{ status: string }> = ({ status }) => {
  return (
    <>
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Ожидание запроса курса</h4>
              <p className="message-course-yes">
                {status === "DOC_ACC"
                  ? "Документы клиента приняты. Ждем запроса курса от клиента"
                  : "Клиент отказался от предложенного курса. Ждем повторного запроса"}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
